import { type MaterialComponentValue, type MaterialProductComponentValue } from 'api';

export const rankMaterialComponents = (
  materialComponents: MaterialComponentValue[] | MaterialProductComponentValue[]
): MaterialComponentValue[] | MaterialProductComponentValue[] => {
  return materialComponents.sort((a, b) => {
    if (a.supported_component.component.name && b.supported_component.component.name) {
      return a.supported_component.component.name.localeCompare(b.supported_component.component.name);
    }
    return 0;
  });
};
